import type { TModule } from '@modules/core/types';

import { USERS_ROUTE_PATHS } from './config';
import { FIND_ROUTES } from './find';
import { KYC_ROUTES } from './kyc';
import { USERS_OPERATIONS_ROUTES } from '@modules/users-operations';
import { COMMUNICATIONS_ROUTES } from './communications';
import { TP_ACCOUNTS_ROUTES } from './tp-accounts';

const usersModule: TModule = {
  id: 'users',
  fallbackRoute: [USERS_ROUTE_PATHS.findUser],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...FIND_ROUTES, ...KYC_ROUTES, ...USERS_OPERATIONS_ROUTES, ...COMMUNICATIONS_ROUTES, ...TP_ACCOUNTS_ROUTES],
};

export { USERS_ROUTE_PATHS as UsersRoutePaths };

export default usersModule;
